/** The signature call-to-action on the sign-in and MFA screens: deep PackPilot green, softly lit. */
export const authButtonSx = {
  minHeight: 50,
  borderRadius: '14px',
  fontSize: '1rem',
  color: '#fff',
  background: 'linear-gradient(135deg, #0A6B5D 0%, #05473E 50%, #033029 100%)',
  boxShadow: '0 10px 24px -10px rgba(67,56,202,0.75), inset 0 1px 0 rgba(255,255,255,0.18)',
  '&:hover': {
    background: 'linear-gradient(135deg, #085A4E 0%, #043D35 50%, #02261F 100%)',
    boxShadow: '0 14px 30px -10px rgba(67,56,202,0.85)',
  },
  '&.Mui-disabled': { color: 'rgba(255,255,255,0.75)', opacity: 0.55 },
} as const;
